<template>
  <v-sheet class="pa-0 text-center">
    <h4 class="grey--text text--darken-1 mb-2">
      {{ headline }}
    </h4>
    <div
      class="chart mx-auto"
      :class="{ empty }"
      :style="{
        width: `${size}px`,
        height: `${size}px`
      }"
    >
      <v-progress-circular
        class="chart__elem"
        v-for="(item, index) in shiftedItems"
        :width="width"
        :size="size"
        :key="index"
        :color="item.color || colors[index]"
        :value="ready ? item.perc : 0"
        :rotate="item.rotate"
      />
      <div class="summary" v-if="!hideSummary">
        <span class="sum">
          {{ sum }}
        </span>
        <div class="items">
          <span
            v-for="(item, index) in summaryItems"
            :key="index"
            :style="{ color: !empty ? (item.color || colors[index]) : 'grey' }"
          >
            {{ item.value }}
          </span>
        </div>
      </div>
    </div>
    <footer class="legend mt-3" v-if="!hideLegend">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="legend__item"
      >
        <i
          v-if="!empty"
          :style="{ backgroundColor: (item.color || colors[index]) }"
        />
        <small>
          {{ item.label }}: <strong>{{ item.value }}</strong>
        </small>
      </div>
    </footer>
  </v-sheet>
</template>

<script>
import ChartReadyMixin from '@/mixins/ChartReadyMixin'
import ColorsMixin from '@/mixins/ColorsMixin'

export default {
  name: 'ChartPie',

  mixins: [ChartReadyMixin, ColorsMixin],

  props: {
    headline: String,
    items: Array,
    sizes: {
      type: Object,
      default: () => ({ lg: 90, md: 70 })
    },
    width: {
      type: Number,
      default: 5
    },
    hideLegend: {
      type: Boolean,
      default: false
    },
    hideSummary: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
    }
  },

  computed: {
    size () {
      const number = this.sizes[this.$vuetify.breakpoint.name]
      return number || 160
    },
    sum () {
      return this.items.reduce((sum, next) => sum + (next.value || 0), 0)
    },
    empty () {
      return this.sum === 0
    },
    shiftedItems () {
      let rotate = 90

      return this.items.map((item) => {
        item.rotate = rotate
        item.value = item.value || 0
        item.perc = item.value ? (item.value / this.sum) * 100 : 0

        rotate += (item.perc * 360) / 100

        return item
      })
    },
    summaryItems () {
      return this.items.slice(0, 3)
    }
  }
}
</script>

<style scoped>
.chart {
  position: relative;
}

.chart.empty {
  filter: grayscale(1);
}

.chart__elem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.legend__item i {
  display: inline-block;
  width: 0.5em;
  height: 0.6em;
  margin-right: 0.25em;
}

.summary {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -56%);
}

.summary .sum {
  font-size: 2em;
  font-weight: 900;
}

.summary .items {
  font-size: 0.75em;
  line-height: 1;
}

.summary .items span + span {
  margin-inline-start: 0.25em;
  padding-inline-start: 0.25em;
  font-weight: bold;
}
</style>

<style>
.chart:not(.empty) .v-progress-circular__underlay {
  stroke: transparent;
}
</style>
